<script lang="tsx">
import { defineComponent, type PropType } from 'vue'
import MultipleDefaultSelect from '../../../../selects/default-select-multiple'
import { type ComputedColumnInterface } from '../../../DefaultTableInterfaces'
import { MultipleDefaultSelectTableFilter } from '../../../filters/Filters'
import { type MultipleDefaultSelectHeaderInterface } from '../../HeadersTableInterfaces'
import HeaderSort from '../DefaultTableHeaderSort.vue'

export default defineComponent({
  props: {
    column: {
      type: Object as PropType<ComputedColumnInterface>,
      required: true,
    },
    sortField: {
      type: String,
      required: true,
    },
    enableSorting: {
      type: Boolean,
    },
    sortOrder: {
      type: Boolean as PropType<boolean>,
    },
    onSort: {
      type: Function as PropType<() => void>,
    },
  },
  setup(props) {
    const filter: MultipleDefaultSelectTableFilter = props.column.filter as unknown as MultipleDefaultSelectTableFilter
    const header: MultipleDefaultSelectHeaderInterface = props.column.header as unknown as MultipleDefaultSelectHeaderInterface

    const setValue = (val: Array<{ id: string, name: string }>) => {
      filter.addValue(val)
    }

    return () => (

      <div class="ark-ui-table-default-select-header default-table-header">
        <MultipleDefaultSelect
          items={header.options}
          placeholder={props.column.name}
          modelValue={filter.value}
          onValueChange={setValue}
          showItemsCount={5}
          hideSearch={header.hideSearch}
        />

        { props.enableSorting && props.onSort && (
          <HeaderSort column={props.column} onSort={props.onSort} sortField={props.sortField} sortOrder={props.sortOrder}/>
        ) }
      </div>

    )
  },
})
</script>

<style lang="scss" scoped>
.ark-ui-table-default-select-header {
  display: flex;

  > *:first-child {
    width: 100%;
  }

  &.active,
  &:hover {
    background-color: transparent !important;
    & path {
      fill: #585B69;
    }
  }
}
</style>
